module.exports = __webpack_public_path__ + "static/media/human.23540bc7.jpg";